import React from 'react';
import PropTypes from 'prop-types';

// MUI components
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemAvatar';
import VerifiedUserTwoToneIcon from '@mui/icons-material/VerifiedUserTwoTone';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';

// Constants
import {
  DISCLOSURE_COMPONENT_TEST_ID,
  DISCLOSURE_RESTRICTED_ICON_TEST_ID,
  DISCLOSURE_NOT_RESTRICTED_ICON_TEST_ID
} from 'testidConstants.js';

const Disclosure = ({isRestricted, text}) => {
  return (
    <ListItem data-testid={DISCLOSURE_COMPONENT_TEST_ID}>
      <ListItemIcon>
        {isRestricted ? (
          <CancelTwoToneIcon color="secondary" data-testid={DISCLOSURE_RESTRICTED_ICON_TEST_ID} />
        ) : (
          <VerifiedUserTwoToneIcon color="primary" data-testid={DISCLOSURE_NOT_RESTRICTED_ICON_TEST_ID} />
        )}
      </ListItemIcon>
      <ListItemText primary={text ? text : isRestricted ? 'Restricted' : 'Not restricted'} />
    </ListItem>
  );
};

Disclosure.propTypes = {
  isRestricted: PropTypes.bool,
  text: PropTypes.string
};

export default Disclosure;
